import styled, { css } from 'styled-components';
import { spaceMixin } from '@zillow/constellation';

const getResponsiveMaxWidth = () => {
  return css`
    margin: 0 auto;
    max-width: 608px;
  `;
};

export const StyledEmptyStateContainer = styled.div`
  text-align: center;
  ${getResponsiveMaxWidth}
`;

export const StyledEmptyIconContainer = styled.div`
  margin-bottom: ${spaceMixin('xs')};
`;
